module.exports = __webpack_public_path__ + "img/office-building-2.6b80013d.png";